import { TranslationsContext } from '@teliaee/telia-translate';
import { observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Text } from 'telia-front-react';
import GravityForm from '../../../forms/GravityForm';
import InternetCalculatorStore from '../../../stores/InternetCalculatorStore';
import LanguageStore from '../../../stores/LanguageStore';
import { Segment } from '../../../stores/SegmentStore';

interface CmsDataStoreKeys {
  addressKey: string;
  roomKey: string;
  internetNameKey: string;
  internetTypeKey: string;
}

interface OrderFormModalContentProps {
  calculatorKey: string;
  cmsDataStoreKeys: CmsDataStoreKeys;
  languageStore?: LanguageStore;
  internetCalculatorStore?: InternetCalculatorStore;
}
@observer
class OrderFormModalContent extends React.Component<OrderFormModalContentProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  @observable accessor showHeaderLabel: boolean = true;

  private PARTNER_FIELD_VALUE_PROVIDERS = [
    {
      data: this.props.cmsDataStoreKeys.addressKey,
      technicalParameter: 'internet_address'
    },
    {
      data: this.props.cmsDataStoreKeys.roomKey,
      technicalParameter: 'internet_room'
    },
    {
      data: this.props.cmsDataStoreKeys.internetNameKey,
      technicalParameter: 'internet_package'
    },
    {
      data: this.props.cmsDataStoreKeys.internetTypeKey,
      technicalParameter: 'internet_type'
    }
  ];

  private resolveHeaderLabel = () => {
    const { internetCalculatorStore, calculatorKey } = this.props;
    const selectedInternet = internetCalculatorStore.getSelectedInternet(calculatorKey);
    const segment: Segment = internetCalculatorStore.getState(calculatorKey).propState.segment;
    if (selectedInternet.partner) {
      if (segment === 'BUSINESS') {
        return 'internetAndTvCalculator.elektrileviInternet.orderForm.header.B2B';
      }
      return 'internetAndTvCalculator.elektrileviInternet.orderForm.header';
    }
    return 'internetAndTvCalculator.teliaInternet.orderForm.header';
  };

  private resolveFormName = () => {
    const {
      internetCalculatorStore,
      calculatorKey,
      languageStore: { currentLanguage }
    } = this.props;
    const selectedInternet = internetCalculatorStore.getSelectedInternet(calculatorKey);
    const segment: Segment = internetCalculatorStore.getState(calculatorKey).propState.segment;
    if (internetCalculatorStore.getState(calculatorKey).propState.partnerFormName) {
      return internetCalculatorStore.getState(calculatorKey).propState.partnerFormName;
    }
    if (selectedInternet.partner && segment !== 'BUSINESS') {
      return `Elektrilevi${currentLanguage}`;
    }
    return `Ärikliendi interneti tellimine_${currentLanguage}`;
  };

  private handleBackClick = () => {
    const { internetCalculatorStore, calculatorKey } = this.props;
    internetCalculatorStore.setOrderFormOpen(calculatorKey, false);
  };

  private handleSubmitSuccess = () => {
    runInAction(() => {
      this.showHeaderLabel = false;
    });
  };

  public render() {
    const { internetCalculatorStore, calculatorKey } = this.props;
    const state = internetCalculatorStore.getState(calculatorKey);
    const translate = this.context.translate;
    if (!state.selectedInternet) {
      return null;
    }
    return (
      <Text>
        {this.showHeaderLabel && <h2>{translate(this.resolveHeaderLabel())}</h2>}
        <GravityForm
          name={this.resolveFormName()}
          backButtonProps={{
            text: translate('gravityForm.dateField.backButtonLabel'),
            iconLeft: '#arrow-left',
            variant: 'secondary',
            onClick: () => this.handleBackClick()
          }}
          fieldValueProviders={this.PARTNER_FIELD_VALUE_PROVIDERS}
          cmsData={internetCalculatorStore.getCmsData(calculatorKey)}
          onSubmitSuccess={this.handleSubmitSuccess}
        />
      </Text>
    );
  }
}

export default inject('internetCalculatorStore', 'languageStore')(OrderFormModalContent);
